import { c as _c } from "react/compiler-runtime";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
interface EventReadAgendaProps {
  event: EventRead;
  title?: string;
}
export const EventReadAgenda: React.FC<EventReadAgendaProps> = t0 => {
  const $ = _c(7);
  const {
    event,
    title: t1
  } = t0;
  const title = t1 === undefined ? "ordre du jour" : t1;
  const content = event.agenda || "Aucun ordre du jour n'a \xE9t\xE9 publi\xE9";
  let t2;
  if ($[0] !== title) {
    t2 = <p className="font-bold uppercase mb-2">{title}</p>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== content) {
    t3 = <p>{content}</p>;
    $[2] = content;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};